import { c as _c } from "react/compiler-runtime";
import IconCopy from '@/assets/icons/heroIcons/Copy.svg';
import { Tooltip } from '@/components/Tooltip';
import { mergeClasses } from '@/utils/style';
import { useTranslation } from 'react-i18next';
import { useCopyToClipboard } from 'react-use';
interface Props {
  value: string;
  helpText?: string;
  className?: string;
}
export function CopyInput(props) {
  const $ = _c(22);
  const [state, copyToClipboard] = useCopyToClipboard();
  const {
    t
  } = useTranslation("core");
  let t0;
  if ($[0] !== props.className) {
    t0 = mergeClasses("relative", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.helpText) {
    t1 = props.helpText && <span className="text-light-gray-500 absolute top-4 left-6 select-none">{props.helpText}</span>;
    $[2] = props.helpText;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.value) {
    t2 = <input className="input font-regular pl-16 text-lg font-medium" value={props.value} onClick={_temp} />;
    $[4] = props.value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== state.error || $[7] !== state.value || $[8] !== t) {
    t3 = !state.error && state.value ? t("copied") : t("error");
    $[6] = state.error;
    $[7] = state.value;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 65];
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== copyToClipboard || $[12] !== props.value) {
    t5 = <span className="text-light-gray-500 absolute top-4 right-4 inline-block cursor-pointer lg:right-10"><IconCopy onClick={() => copyToClipboard(props.value)} /></span>;
    $[11] = copyToClipboard;
    $[12] = props.value;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <Tooltip tooltip={t3} trigger="click" placement="top" offset={t4}>{t5}</Tooltip>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t0 || $[18] !== t1 || $[19] !== t2 || $[20] !== t6) {
    t7 = <div className={t0}>{t1}{t2}{t6}</div>;
    $[17] = t0;
    $[18] = t1;
    $[19] = t2;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp(e) {
  return e.currentTarget.select();
}